import { useAppSelector } from "../../../../../stateManagement/hooks/redux"

// RoadAccidents
export default function RAContent() {

    const mapTooltip = useAppSelector(state => state.mapTooltip)
    const { roadAccidentDate, roadAccidentDeathRoll, roadAccidentTime, roadAccidentType, roadAccidentWoundedCount } = mapTooltip ?? {}

    return (
        <>
            <div className="tooltip-info-row">Дата: {roadAccidentDate}</div>
            <div className="tooltip-info-row">Время: {roadAccidentTime}</div>
            <div className="tooltip-info-row">Вид ДТП: {roadAccidentType}</div>
            <div className="tooltip-info-row">Число погибших: {roadAccidentDeathRoll}</div>
            <div className="tooltip-info-row">Число раненых: {roadAccidentWoundedCount}</div>
        </>
    )
}
